import { Column } from '@tanstack/react-table';
import { CSSProperties, useMemo } from 'react';

export function useCommonPinningStyles<T>(column: Column<T>, isOverflowing = true): CSSProperties {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn = isPinned === 'left' && column.getIsLastColumn('left');
  const isFirstRightPinnedColumn = isPinned === 'right' && column.getIsFirstColumn('right');

  const left = isPinned === 'left' ? `${column.getStart('left')}px` : undefined;
  const right = isPinned === 'right' ? `${column.getAfter('right')}px` : undefined;
  return useMemo(
    () => ({
      transition: 'box-shadow 0.2s ease-in-out',
      transitionProperty: 'box-shadow, border-color',
      boxShadow: isLastLeftPinnedColumn
        ? isOverflowing
          ? '4px 0 4px 0 #99999929'
          : '4px 0 4px 0 #99999900'
        : isFirstRightPinnedColumn
          ? isOverflowing
            ? '-4px 0 4px 0 #99999929'
            : '-4px 0 4px 0 #99999900'
          : undefined,
      borderLeftColor: isFirstRightPinnedColumn && isOverflowing ? 'transparent' : undefined,
      borderRightColor: isLastLeftPinnedColumn && isOverflowing ? 'transparent' : undefined,
      clipPath: isPinned ? 'inset(0 -10px)' : undefined,
      left,
      right,
      opacity: isPinned ? 0.95 : 1,
      position: isPinned ? 'sticky' : undefined,
      zIndex: isPinned ? 1 : undefined,
    }),
    [isFirstRightPinnedColumn, isLastLeftPinnedColumn, isOverflowing, isPinned, left, right],
  );
}
